import {useEffect, useRef, useState} from 'react';

const useClassListWithImages = (setState, class_id, isInActive) => {
    const containerElement = useRef<Element | any>(null);
    const scrollElement = useRef<Element | any>(null);
    const [isHover, setIsHover] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isActiveAddClass, setIsActiveAddClass] = useState(false);

    /**
     * scrollHorizontal - on image gallery small images
     * @param isLeft - is trun left or right
     */
    const scrollHorizontal = (isLeft) => {
        if ('current' in scrollElement) {
            window.scrollTo({
                left: isLeft ? scrollElement.current.scrollLeft -= 88 : scrollElement.current.scrollLeft += 88,
                behavior: 'smooth'
            });
        }
    };

    /**
     * handleClickOutside of box
     * @param e - event
     */
    const handleClickOutside = (e) => {
        if (containerElement.current && !containerElement.current.contains(e.target)) {
            setIsActiveAddClass(true);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (isActiveAddClass && isInActive && !isOpenModal) {
            setState({activeAddClass: class_id});
        }
        setIsActiveAddClass(false);
    }, [isActiveAddClass]);

    return {scrollElement, scrollHorizontal, isHover, setIsHover, handleClickOutside, containerElement, setIsOpenModal};
};

export default useClassListWithImages;
